<template>
  <el-dialog v-model="visible" class="small-dialog" :title="$t('Reset your password')" :append-to-body="true">
    <el-form ref="refForm" class="form-container" :model="formData" :rules="formRules" onsubmit="return false" @keyup.enter="submitForm(refForm)">
      <input type="text" placeholder="User Account" :value="props.account" style="padding: 0; height: 0; opacity: 0; border: none;" />
      <el-form-item prop="password" class="form-item">
        <el-input class="form-input" type="password" v-model="formData.password" show-password autocomplete="new-password" :placeholder="$t('Enter new password')" />
      </el-form-item>
      <el-form-item prop="rePassword" class="form-item">
        <el-input class="form-input" type="password" v-model="formData.rePassword" show-password autocomplete="new-password" :placeholder="$t('Enter your password again')" />
      </el-form-item>
      <el-form-item class="form-item">
        <el-button type="primary" class="submit-btn" @click="handleChangePassword()" :loading="submitBtnLoading">{{ $t('Continue') }}</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script setup>
import { resetPassword } from '@/api/user/user'
import regexPattern from '@/libs/regex-patterns'
import { userStore } from '@/stores'
import { ElMessage } from 'element-plus'
import { getCurrentInstance, reactive, ref } from 'vue'

const { $t } = getCurrentInstance().proxy

const emits = defineEmits(['on-success'])

const props = defineProps({
  // 账号：邮箱或手机号
  account: {
    type: String,
    default: '',
  },
  // 验证码id
  codeId: {
    type: String,
    default: '',
  },
  // 验证码
  code: {
    type: Number,
    default: 0,
  },
})

const visible = ref(false)
const show = () => {
  visible.value = true
}

const formData = reactive({
  password: '',
  rePassword: '',
  codeId: '',
  code: 0,
  username: '',
})

const formRules = reactive({
  password: [
    {
      validator: (rule, value, callback) => {
        if (value !== '') {
          if (!regexPattern.password.test(value)) {
            const msg = $t('Password must be 6-20 characters, and should have numbers, English letters, or symbols.')
            callback(new Error(msg))
          } else {
            callback()
          }
        } else {
          callback()
        }
      },
      trigger: 'blur',
    },
  ],
  rePassword: [
    { required: true, message: $t('Please enter your password again'), trigger: 'blur' },
    {
      validator: (rule, value, callback) => {
        if (value.length < formData.password.length) {
          callback(new Error(''))
        } else if (value === '' || value === formData.password) {
          callback()
        } else {
          callback(new Error($t("Those passwords didn\'t match. Try again.")))
        }
      },
      trigger: 'change',
    },
  ],
})

// 提交修改密码
const refForm = ref(null)
const submitBtnLoading = ref(false)
const handleChangePassword = () => {
  refForm.value.validate(async valid => {
    if (valid) {
      if (submitBtnLoading.value) return
      submitBtnLoading.value = true
      try {
        formData.codeId = props.codeId
        formData.code = props.code
        formData.username = props.account
        await resetPassword(formData)
        ElMessage.success($t('Set success'))
        userStore.userInfo.hasPassword = true
        emits('on-success')
        visible.value = false
      } catch (error) {
        submitBtnLoading.value = false
      }
    }
  })
}

defineExpose({
  show,
})
</script>

<style lang="scss" scoped>
.form-container {
  padding: 32px 0;
  .submit-btn {
    width: 100%;
  }
}
</style>
